import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { CENTER_CTA_VERBS, SURFACE_FIELDS, fieldGuideFor } from '../../../helpers/notification_registry_helpers';

// The verb on the Notification Center button: one of the standard verbs, or a custom one typed
// under the limit. Shared by the New form and the entry page so the two cannot drift.

const CUSTOM_VERB = '__custom__';
const LIMIT = SURFACE_FIELDS.center_cta.verb;

const ButtonVerbField = ({ verb, isCustom, onPick, onCustom, onType, onBlur, className }) => {
  const showCustom = isCustom || (!!verb && !CENTER_CTA_VERBS.includes(verb));
  return (
    <>
      <select
        className={className}
        value={showCustom ? CUSTOM_VERB : verb || 'View'}
        onChange={e => {
          if (e.target.value === CUSTOM_VERB) return onCustom();
          onPick(e.target.value === 'View' ? '' : e.target.value);
        }}
      >
        {CENTER_CTA_VERBS.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
        <option value={CUSTOM_VERB}>Custom…</option>
      </select>
      {showCustom && <input className={cn('custom-verb', className)} value={verb} onChange={e => onType(e.target.value)} onBlur={onBlur} />}
      <span className='field-guide'>
        {fieldGuideFor('center_cta', 'verb')}
        {showCustom && (
          <span className={cn('counter', { over: verb.length > LIMIT })}>
            {verb.length} / {LIMIT} recommended
          </span>
        )}
      </span>
    </>
  );
};

ButtonVerbField.propTypes = {
  verb: PropTypes.string.isRequired,
  isCustom: PropTypes.bool.isRequired,
  onPick: PropTypes.func.isRequired,
  onCustom: PropTypes.func.isRequired,
  onType: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  className: PropTypes.string
};

export default ButtonVerbField;
